import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./themes/default";
import { Amplify } from "aws-amplify";
import { NotificationContainer } from "./components/notification/NotificationContainer";
import { ModalManager } from "./context/ModalManager";
import { UserContextProvider } from "./context/UserContextProvider";
import { PoliciesContextProvider } from "./context/PoliciesContextProvider";
import { DialogManager } from "./context/DialogManager";
import { Outlet } from "react-router-dom";
import { PartnerLayoutContextProvider } from "./context/PartnerLayoutContextProvider";
import { AffiliateSignupsContextProvider } from "./context/AffiliateSignupsContextProvider";
import { BrowserTracing, Replay } from "@sentry/react";
import * as Sentry from "@sentry/react";
import RobotsMeta from "./util/robotsMeta";
import { useCompanyStoreInit } from "./stores/useCompanyStore";

const config = {
  aws_project_region: process.env.REACT_APP_REGION,
  aws_cognito_region: process.env.REACT_APP_REGION,
  aws_user_pools_id: process.env.REACT_APP_COGNITO_USER_POOL,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
};
Amplify.configure(config);

if (process.env.REACT_APP_SENTRY_DSN && process.env.REACT_APP_ENV === "prod") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing(), new Replay()],
    tracesSampleRate: process.env.REACT_APP_ENV === "prod" ? 0.2 : 1,
    replaysSessionSampleRate: process.env.REACT_APP_ENV === "prod" ? 0.1 : 1,
    replaysOnErrorSampleRate: 1,
    environment: "production",
    // process.env.REACT_APP_ENV === "dev"
    //   ? "development"
    //   : process.env.REACT_APP_ENV === "stage"
    //   ? "staging"
    //   : process.env.REACT_APP_ENV === "prod"
    //   ? "production"
    //   : "development",
  });
} else {
  console.log("ERROR SETTING SENTRY", process.env.REACT_APP_SENTRY_DSN);
}

const queryClient = new QueryClient();

function App(): JSX.Element {
  useCompanyStoreInit();
  return (
    <>
      <RobotsMeta mainDomain="toolkit.fena.co" />
      <div className="App">
        <QueryClientProvider client={queryClient}>
          <UserContextProvider>
            <AffiliateSignupsContextProvider>
              <PoliciesContextProvider>
                <PartnerLayoutContextProvider>
                  <ThemeProvider theme={defaultTheme}>
                    <ModalManager>
                      <DialogManager>
                        <Outlet />
                      </DialogManager>
                    </ModalManager>
                    <NotificationContainer />
                  </ThemeProvider>
                </PartnerLayoutContextProvider>
              </PoliciesContextProvider>
            </AffiliateSignupsContextProvider>
          </UserContextProvider>
        </QueryClientProvider>
      </div>
    </>
  );
}

export default App;
